var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 33,
    viewBox: "0 0 48 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1991_108040)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 32,
    rx: 6,
    fill: "url(#paint0_linear_1991_108040)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0.5V0H23.5V0.5H9.6C6.23969 0.5 4.55953 0.5 3.27606 1.15396C2.14708 1.7292 1.2292 2.64708 0.653961 3.77606C0.174035 4.71796 0.046315 5.87352 0.0123256 7.75H0V8.25H0.00547604C0 8.80455 0 9.41763 0 10.1V16.5V17V22.9C0 23.5824 0 24.1955 0.00547604 24.75H0V25.25H0.0123256C0.046315 27.1265 0.174035 28.282 0.653961 29.2239C1.2292 30.3529 2.14708 31.2708 3.27606 31.846C4.55953 32.5 6.23968 32.5 9.6 32.5H23.5V33H24V32.5H38.4C41.7603 32.5 43.4405 32.5 44.7239 31.846C45.8529 31.2708 46.7708 30.3529 47.346 29.2239C47.826 28.282 47.9537 27.1265 47.9877 25.25H48V24.75H47.9945C48 24.1955 48 23.5824 48 22.9V17V16.5V10.1C48 9.41763 48 8.80455 47.9945 8.25H48V7.75H47.9877C47.9537 5.87352 47.826 4.71796 47.346 3.77606C46.7708 2.64708 45.8529 1.7292 44.7239 1.15396C43.4405 0.5 41.7603 0.5 38.4 0.5H24ZM23.5 1H9.6C7.91159 1 6.67536 1.00039 5.69993 1.08008C4.73034 1.1593 4.06255 1.31438 3.50305 1.59946C2.46816 2.12677 1.62677 2.96816 1.09946 4.00305C0.814384 4.56255 0.659303 5.23034 0.580085 6.19993C0.543006 6.65374 0.523095 7.16401 0.512402 7.75H14H14.0757L14.1387 7.79199L18.2007 10.5H18.5H23.5V1ZM0.505516 8.25C0.500064 8.80035 0.5 9.41271 0.5 10.1V16.5H18V11V10.9671L13.9243 8.25H0.505516ZM0.5 17V22.9C0.5 23.5873 0.500064 24.1997 0.505516 24.75H13.9243L18 22.0329V22V17H0.5ZM0.512402 25.25C0.523095 25.836 0.543006 26.3463 0.580085 26.8001C0.659303 27.7697 0.814384 28.4374 1.09946 28.9969C1.62677 30.0318 2.46816 30.8732 3.50305 31.4005C4.06255 31.6856 4.73034 31.8407 5.69993 31.9199C6.67536 31.9996 7.91159 32 9.6 32H23.5V22.5H18.5H18.2007L14.1387 25.208L14.0757 25.25H14H0.512402ZM24 32H38.4C40.0884 32 41.3246 31.9996 42.3001 31.9199C43.2697 31.8407 43.9374 31.6856 44.4969 31.4005C45.5318 30.8732 46.3732 30.0318 46.9005 28.9969C47.1856 28.4374 47.3407 27.7697 47.4199 26.8001C47.457 26.3463 47.4769 25.836 47.4876 25.25H34H33.9243L33.8613 25.208L29.7993 22.5H29.5H24V32ZM47.4945 24.75C47.4999 24.1997 47.5 23.5873 47.5 22.9V17H30V22V22.0329L34.0757 24.75H47.4945ZM47.5 16.5V10.1C47.5 9.41271 47.4999 8.80035 47.4945 8.25H34.0757L30 10.9671V11V16.5H47.5ZM47.4876 7.75H34H33.9243L33.8613 7.79199L29.7993 10.5H29.5H24V1H38.4C40.0884 1 41.3246 1.00039 42.3001 1.08008C43.2697 1.1593 43.9374 1.31438 44.4969 1.59946C45.5318 2.12677 46.3732 2.96816 46.9005 4.00305C47.1856 4.56255 47.3407 5.23034 47.4199 6.19993C47.457 6.65374 47.4769 7.16401 47.4876 7.75ZM23.5 22H18.5V11H23.5H24H29.5V22H24H23.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1991_108040",
    x1: 0,
    y1: 0.5,
    x2: 12,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5CF93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4CEA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1991_108040"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 32,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.0609ba3a7ffaa0a49eb7bce2c3b240df.svg";
export { ForwardRef as ReactComponent };